import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Menu, MenuItem } from '@mui/material'
import { colors } from '../../../tokens/colors'
import { typography } from '../../../tokens/typography'

const focusStyle = css`
  &:focus-visible {
    outline: transparent;
    box-shadow: 0px 0px 0px 2px ${colors.interactive.shadowHoverLightBlue};
  }
`

export const NavItemButton = styled.button<{
  isActive: boolean
  isCollapsed?: boolean
}>`
  display: flex;
  justify-content: ${({ isCollapsed }) =>
    isCollapsed ? 'center' : 'space-between'};
  background: ${({ isActive }) => (isActive ? `var(--navItemActive)` : 'none')};
  border-radius: ${({ isCollapsed }) => (isCollapsed ? '4px' : '4px 0 0 4px')};
  border: none;
  padding: ${({ isCollapsed }) => (isCollapsed ? '10px 0' : '10px')};
  margin: ${({ isCollapsed }) => (isCollapsed ? '4.5px auto' : '4.5px')};
  margin-left: ${({ isCollapsed }) => (isCollapsed ? 'auto' : '28px')};
  margin-right: ${({ isCollapsed }) => (isCollapsed ? 'auto' : '0')};
  align-items: center;
  gap: ${({ isCollapsed }) => (isCollapsed ? '0' : '12px')};
  cursor: pointer;
  text-decoration: none;
  width: ${({ isCollapsed }) => (isCollapsed ? '70px' : '212px')};

  /* Add smooth transitions for all properties that change */
  transition: all 0.2s ease-in-out;

  &:hover {
    transition: background 0.1s ease-in;
    background: var(--navItemHover);
  }

  ${focusStyle}

  &:active {
    box-shadow: none;
  }
`

export const NavItemLabel = styled.h3<{
  isIcon?: boolean
  isCollapsed?: boolean
}>`
  ${typography.baseline.regularSans}
  color: ${colors.copy.headerLight};
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: ${({ isCollapsed }) =>
    isCollapsed ? 'center' : 'flex-start'};
  min-height: 24px; /* Add a fixed height */
  transition: all 0.2s ease-in-out;
  ${({ isIcon, isCollapsed }) =>
    isIcon &&
    isCollapsed &&
    `
    width: 100%;
    text-align: center;
  `}
  text-align: ${({ isCollapsed }) => (isCollapsed ? 'center' : 'left')};
`

export const NavItemIconLabelGroup = styled.div<{
  isCollapsed?: boolean
}>`
  display: flex;
  width: 100%;
  justify-content: ${({ isCollapsed }) =>
    isCollapsed ? 'center' : 'space-between'};
  align-items: center;
  transition: all 0.2s ease-in-out;
`

export const NavItemLabelAndIconContainer = styled.div<{
  isCollapsed?: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: ${({ isCollapsed }) =>
    isCollapsed ? 'center' : 'flex-start'};
  gap: 12px;
  width: ${({ isCollapsed }) => (isCollapsed ? '100%' : 'auto')};
  transition: all 0.2s ease-in-out;
`

export const NavItemMenu = styled(Menu)`
  & .MuiPaper-root {
    background: var(--navItemBackground);
    border-radius: 4px;
    border: none;
  }
`

export const NavItemMenuItem = styled(MenuItem)<{ href?: string }>`
  ${typography.baseline.regularSans}
  padding: 0;

  a {
    display: inline-block;
    color: ${colors.copy.headerLight};
    text-decoration: none;
    padding: 10px 28px;
    width: 100%;
    text-align: left;
  }

  &:hover {
    transition: background 0.1s ease-in;
    background: var(--navItemHover);
  }
`
